if (!customElements.get('ofit-details-tabs')) {
  customElements.define('ofit-details-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const panels = [...this.querySelectorAll('details')];
      if (!panels.length) return;
      const list = document.createElement('div');
      list.className = 'ofit-details-tablist';
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', 'Product information');
      const prefix = this.closest('[id]')?.id || 'product-information';
      const select = index => panels.forEach((panel, i) => {
        panel.open = i === index;
        panel.hidden = i !== index;
        list.children[i].setAttribute('aria-selected', String(i === index));
        list.children[i].tabIndex = i === index ? 0 : -1;
      });
      panels.forEach((panel, i) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.textContent = panel.querySelector('summary').textContent;
        tab.id = `${prefix}-tab-${i}`;
        panel.id = `${prefix}-panel-${i}`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % panels.length;
          if (event.key === 'ArrowLeft') next = (i + panels.length - 1) % panels.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = panels.length - 1;
          if (next === undefined) return;
          event.preventDefault(); select(next); list.children[next].focus();
        });
        list.append(tab);
      });
      this.prepend(list);
      select(0);
      this.dataset.ready = 'true';
    }
  });
}
